import { render, staticRenderFns } from "./previewResultsList.vue?vue&type=template&id=0c960475&scoped=true"
import script from "./previewResultsList.vue?vue&type=script&lang=js"
export * from "./previewResultsList.vue?vue&type=script&lang=js"
import style0 from "./previewResultsList.vue?vue&type=style&index=0&id=0c960475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c960475",
  null
  
)

export default component.exports